"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconBusiness = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M32.3 16.92h17a1.6 1.6 0 1 0 0-3.2h-17a1.6 1.6 0 1 0 0 3.2z"
  }), _react["default"].createElement("path", {
    d: "M62.72 46.41h-4.95V7.82a1.6 1.6 0 0 0-1.6-1.6H25.46a1.6 1.6 0 0 0-1.6 1.6v11.12H7.28a1.6 1.6 0 0 0-1.6 1.6v41.64a1.6 1.6 0 0 0 1.6 1.6h55.44a1.6 1.6 0 0 0 1.6-1.6V48a1.6 1.6 0 0 0-1.6-1.59zM8.88 22.14H30v38.44H8.88zM54.57 9.42v37H33.16v-4h16.17a1.6 1.6 0 1 0 0-3.2H33.16v-5.33h16.17a1.6 1.6 0 1 0 0-3.2H33.16v-5.28h16.17a1.6 1.6 0 0 0 0-3.2H33.16v-1.67a1.6 1.6 0 0 0-1.6-1.6h-4.5V9.42zm6.55 51.17h-28v-11h28z"
  }), _react["default"].createElement("path", {
    d: "M14.91 47.25h9.43a1.6 1.6 0 1 0 0-3.2h-9.43a1.6 1.6 0 0 0 0 3.2zM14.91 38h9.43a1.6 1.6 0 1 0 0-3.2h-9.43a1.6 1.6 0 0 0 0 3.2zM14.91 28.75h9.43a1.6 1.6 0 1 0 0-3.2h-9.43a1.6 1.6 0 0 0 0 3.2zM24.34 56.5a1.6 1.6 0 1 0 0-3.2h-9.43a1.6 1.6 0 0 0 0 3.2zM53.32 53.5H41.56a1.6 1.6 0 0 0 0 3.2h11.76a1.6 1.6 0 0 0 0-3.2z"
  })),
  height: undefined,
  width: undefined
});
IconBusiness.displayName = 'IconBusiness';
var _default = IconBusiness;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/business.js
// module id = 329
// module chunks = 0